// @ts-nocheck
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-param-reassign */
/* eslint-disable no-throw-literal */
/* eslint-disable no-empty */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
import AppConfigs from "configs/env";
import axios from "axios";
import { CAMPAIGNID, SHOW_POPUP_REDIRECT_LOGIN, TENANTID } from "constants/common";
import eventEmitter from "help/eventEmitter";

const REQUEST_TIMEOUT = 60000;


const headersDefault = {
  "Content-Type": "application/json",
  Accept: "application/json; charset=utf-8",
  "Access-Control-Allow-Origin": "*",
  "Api-version": AppConfigs.apiVersion,
  "Ocp-Apim-Subscription-Key": AppConfigs.subscriptionKeyCampaign,
  e_platform: "Web",
  tenantId: TENANTID,
  campaignId: CAMPAIGNID,
};

const buildURLWithParams = (url, params = {}) => {
  let requestedURL = url;
  if (params) {
    const keys = Object.keys(params);

    if (Array.isArray(keys) && keys.length > 0) {
      requestedURL += "?";
      for (const property of keys) {
        const index = keys.indexOf(property);
        if (index > 0 && index < keys.length) {
          requestedURL += "&";
        }
        requestedURL += `${property}=${params[property]}`;
      }
    }
  }
  return requestedURL;
};

const onEmitRedirectLogin = () => {
  eventEmitter.emit(SHOW_POPUP_REDIRECT_LOGIN);
}

export default class APIUtils {
  static get(url, config = { headers: {}, params: {} }) {
    // console.log("APIUtils>>>>>");
    return new Promise(async (resolve, reject) => {
      const { headers, params, ...restConfig } = config;
      const requestedURL = buildURLWithParams(url, params);

      // eslint-disable-next-line no-undef
      const controller = new AbortController();
      const { signal } = controller;
      const accessToken = localStorage.getItem("accessToken");

      const fetchConfig = {
        cache: "default",
        credentials: "include",
        headers: {
          ...headersDefault,
          ...config.headers,
          Authorization: !!accessToken ? `Bearer ${accessToken}` : "",
        },
        ...restConfig,
        method: "GET",
        signal,
      };

      setTimeout(() => {
        controller.abort();
      }, REQUEST_TIMEOUT);
      // console.log(">>>>>request>>>>>", {
      //   url: requestedURL,
      //   config: fetchConfig,
      // });

      axios({ ...fetchConfig, url: requestedURL })
        .then(async (response) => {
          // console.log(">>>>>response>>>>>", { url, data: response.data });

          resolve(response);
        })
        .catch((error) => {
          // console.log(">>>>>error>>>>>", { url: requestedURL, error });
          if (error?.response?.status === 401) {
            onEmitRedirectLogin();
            return;
          }
          let err = {
            data: error?.response?.data,
            status: error?.response?.status,
          };
          reject(err);
        });
    });
  }

  static post(url, config = { headers: {} }) {
    return new Promise(async (resolve, reject) => {
      const { headers, body, params, ...restConfig } = config;

      // eslint-disable-next-line no-undef
      const controller = new AbortController();
      const { signal } = controller;
      const accessToken = localStorage.getItem("accessToken");

      const fetchConfig = {
        cache: "default",
        credentials: "include",
        headers: {
          ...headersDefault,
          ...config.headers,
          Authorization: !!accessToken ? `Bearer ${accessToken}` : "",
        },
        ...restConfig,
        signal,
        method: "POST",
        data: config.body,
      };
      setTimeout(() => {
        controller.abort();
      }, REQUEST_TIMEOUT);
      // console.log(">>>>>request>>>>>", {
      //   url,
      //   config: fetchConfig,
      // });
      axios({ ...fetchConfig, url })
        .then(async (response) => {
          // console.log(">>>>>response>>>>>", { url, data: response.data });

          resolve(response);
        })
        .catch((error) => {
          // console.log(">>>>>error>>>>>", { url, ...error.response });
          if (error?.response?.status === 401) {
            onEmitRedirectLogin();
            return;
          }
          let err = {
            data: error?.response?.data,
            status: error?.response?.status,
          };
          reject(err);
        });
    });
  }

  static delete(url, config = { headers: {} }) {
    return new Promise(async (resolve, reject) => {
      const { headers, body, params, ...restConfig } = config;

      // eslint-disable-next-line no-undef
      const controller = new AbortController();
      const { signal } = controller;
      const accessToken = localStorage.getItem("accessToken");

      const fetchConfig = {
        cache: "default",
        credentials: "include",
        headers: {
          ...headersDefault,
          ...config.headers,
          Authorization: !!accessToken ? `Bearer ${accessToken}` : "",
        },
        ...restConfig,
        signal,
        method: "DELETE",
        body: JSON.stringify(config.body),
      };
      setTimeout(() => {
        controller.abort();
      }, REQUEST_TIMEOUT);
      // console.log(">>>>>request>>>>>", {
      //   url,
      //   config: fetchConfig,
      // });
      axios({ ...fetchConfig, url })
        .then(async (response) => {
          // console.log(">>>>>response>>>>>", { url, data: response.data });

          resolve(response);
        })
        .catch((error) => {
          // console.log(">>>>>error>>>>>", { url, error });
          if (error?.response?.status === 401) {
            onEmitRedirectLogin();
            return;
          }
          let err = {
            data: error?.response?.data,
            status: error?.response?.status,
          };
          reject(err);
        });
    });
  }

  static put(url, config = { headers: {} }) {
    return new Promise(async (resolve, reject) => {
      const { headers, body, params, ...restConfig } = config;

      // eslint-disable-next-line no-undef
      const controller = new AbortController();
      const { signal } = controller;
      const accessToken = localStorage.getItem("accessToken");

      const fetchConfig = {
        cache: "default",
        credentials: "include",
        headers: {
          ...headersDefault,
          ...config.headers,
          Authorization: !!accessToken ? `Bearer ${accessToken}` : "",
        },
        ...restConfig,
        signal,
        method: "PUT",
        data: config.body,
      };
      setTimeout(() => {
        controller.abort();
      }, REQUEST_TIMEOUT);
      // console.log(">>>>>request>>>>>", {
      //   url,
      //   config: fetchConfig,
      // });
      axios({ ...fetchConfig, url })
        .then(async (response) => {
          // console.log(">>>>>response>>>>>", { url, data: response.data });

          resolve(response);
        })
        .catch((error) => {
          // console.log(">>>>>error>>>>>", { url, error });
          if (error?.response?.status === 401) {
            onEmitRedirectLogin();
            return;
          }
          let err = {
            data: error?.response?.data,
            status: error?.response?.status,
          };
          reject(err);
        });
    });
  }
}
